import { retryLazy } from '@utils/lazyLoad';

export const LandingPage = retryLazy(() => import('./LandingPage'));

export const AuthNaver = retryLazy(() => import('./auth/AuthNaver'));
export const AuthKakao = retryLazy(() => import('./auth/AuthKakao'));
export const AuthApple = retryLazy(() => import('./auth/AuthApple'));

export const JoinPage = retryLazy(() => import('./JoinPage'));
export const InvitationAcceptPage = retryLazy(() => import('./InvitationAcceptPage'));
export const LoginPage = retryLazy(() => import('./LoginPage'));
export const PhoneLoginPage = retryLazy(() => import('./PhoneLoginPage'));
export const EmailLoginPage = retryLazy(() => import('./EmailLoginPage'));
export const DashboardPage = retryLazy(() => import('./DashboardPage'));
export const ProfileEditPage = retryLazy(() => import('./ProfileEditPage'));
export const AccountPage = retryLazy(() => import('./AccountPage'));
export const PartnerUserPage = retryLazy(() => import('./PartnerUserPage'));
export const ProductsPage = retryLazy(() => import('./ProductsPage'));
export const LastChanceProductsPage = retryLazy(() => import('./LastChanceProductsPage'));
export const ProductOrdersPage = retryLazy(() => import('./ProductOrdersPage'));
export const ProgramInvoicePage = retryLazy(() => import('./ProgramInvoicePage'));
export const SettlementsPage = retryLazy(() => import('./SettlementsPage'));
export const ProgramAfterCarePage = retryLazy(() => import('./ProgramAfterCarePage'));
export const InvoicePage = retryLazy(() => import('./InvoicePage'));
export const ReviewsPage = retryLazy(() => import('./ReviewsPage'));
export const UserContentsPage = retryLazy(() => import('./UserContentsPage'));
export const UserContentEditorPage = retryLazy(() => import('./UserContentEditorPage'));
export const MembershipUsersPage = retryLazy(() => import('./MembershipUsersPage'));
export const MembershipProductsPage = retryLazy(() => import('./MembershipProductsPage'));
export const ChatPage = retryLazy(() => import('./ChatPage'));
export const ChatSettingPage = retryLazy(() => import('./ChatSettingPage'));
export const NoticePage = retryLazy(() => import('./NoticePage'));
export const NoticeDetailPage = retryLazy(() => import('./NoticeDetailPage'));

export const NotFoundPage = retryLazy(() => import('./NotFound'));
export const RedirectToExternal = retryLazy(() => import('./RedirectToExternal'));

export const MySchedulePage = retryLazy(() => import('./MySchedulePage'));

export const InstructorsPage = retryLazy(() => import('./InstructorsPage'));
export const ProgramSchedulesPage = retryLazy(() => import('./ProgramSchedulesPage'));
export const ReservationSuccessPage = retryLazy(() => import('./ReservationSuccessPage'));
export const ProgramScheduleGroupPage = retryLazy(() => import('./ProgramScheduleGroupPage'));
export const GroupingPolicySettingsPage = retryLazy(() => import('./GroupingPolicySettingsPage'));
export const ReportsPage = retryLazy(() => import('./ReportsPage'));
